import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BotonToggleModule } from "../../../components/boton/boton-toggle.module";
import { MaterialModule } from "../../../components/material/material.module";
import { NgxPermissionsModule } from "ngx-permissions";
// import { EstadosPropuestaRoutingModule } from "./estados-propuesta-routing.module";
import { ContactosComponent } from "./contactos.component";
import { ContactosRoutingModule } from "./contactos-routing.module";
import { ContactoModule } from "../../../forms/contactos/contacto.module";
import { ImportarDialog } from "../../../components/personas/dialog-importar/importar-dialog.component";
import { PersonasModule } from "../../../components/personas/personas.module";
import { VolverModule } from "../../../components/volver/volver.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        BotonToggleModule,
        MaterialModule,
        // EstadosPropuestaRoutingModule,
        ContactosRoutingModule,
        ContactoModule,
        PersonasModule,
        BotonToggleModule,
        MaterialModule,
        VolverModule,
    ],
    declarations: [
        ContactosComponent
    ],
    providers: [
    ],
    entryComponents: [
    ]
})
export class ContactosModule { }
